import HSFilledIcon from './hs-filled-icon';

export default HSFilledIcon;
